import React from 'react';
import Header from '../../Components/Header/Header';

class Explore extends React.Component{
    render(){
        return(
            <div>
                <h1>Explore</h1>
            </div>
        )
    }
}

export default Explore;